<template>
  <div>
    
    <Dialog id="dialogRecuperarSenha" titulo="Recuperar senha" ref="dialog" :modal="false" :hideFooter="true" :tituloCenter="true">
      <form class="text-left">

        <div
      v-if="mensagem !== ''"
      class="alert alert-success alert-dismissible fade show"
      role="alert"
    >
      <strong>{{mensagem}}</strong>
    </div>
        
        <div class="form-group row">
          <label for="email" class="col-sm-12 col-form-label">Email</label>
          <div class="col-sm-12">
            <input
              class="form-control"
              v-bind:class="{ 'is-invalid': itemErros.email.status }"
              type="text"
              v-model="item.email"
            />
            <div
              v-if="itemErros.email.status"
              class="invalid-feedback"
            >{{ itemErros.email.mensagem }}</div>
          </div>
        </div>

        <div class="text-center">

          <button style="margin-top:10px" type="button" class="btn btn-primary" @click="novaSenha()">Enviar nova senha</button>

          <p style="margin-top:10px;margin-bottom:5px"><a href="/">Retornar ao login</a></p>

        </div>

      </form>

    </Dialog>

  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";

export default {
  name: "LoginRecuperarSenhaEmail",
  components: { Dialog },
  methods: {
    async novaSenha() {
      //var objPagina = this;

      //* Limpa os erros
      this.itemErros = util.errosLimpar(this.itemErros);

      //* Carrega os dados
      const apiRequest = await api.post("/usuario/recuperar-senha", this.item);

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);
      } else {
        this.mensagem = "Nova senha enviada para o e-mail!";

        /*setTimeout(function () {
          objPagina.$router.push({ name: "login" });
        }, 3000);*/

      }
    },
  },
  mounted() {},
  data: function () {
    return {
      item: {
        email: "",        
      },
      mensagem: "",
      itemErros: {
        email: { status: false, mensagem: "" }
        
      },
    };
  },
};
</script>

<style></style>
